import { render, staticRenderFns } from "./PressList.vue?vue&type=template&id=1c01a0b6&scoped=true"
import script from "./PressList.vue?vue&type=script&lang=js"
export * from "./PressList.vue?vue&type=script&lang=js"
import style0 from "./PressList.vue?vue&type=style&index=0&id=1c01a0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01a0b6",
  null
  
)

export default component.exports